import { render, staticRenderFns } from "./FeecontractIndex.vue?vue&type=template&id=53dc24c8"
import script from "./FeecontractIndex.vue?vue&type=script&lang=js"
export * from "./FeecontractIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports